import React from 'react'
import styled from 'styled-components'

import zen from '../images/zen.png';
import heart from '../images/heart.png';
import speed from '../images/speed.png';

const BenefitsWrapper = styled.div`
    width:100vw;
    max-width:100%;
    height:auto;
    background: ${({ theme }) => theme.body};
    text-align:center;
    margin-bottom:3rem;
    padding-top: 3.5rem;
    display:flex;
    flex-direction:column;
    justify-items:center;
    align-items:center;
    @media (max-width: 750px){
        padding-top: 0;
    }
`

const Columns = styled.div`
    width:100vw;
    max-width:90%;
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items:center;
    flex:1;
    grid-column-gap:3rem;
    
    /*mobile view */
    @media (max-width: 750px){
        grid-template-columns: repeat(1, 1fr);
    }
`
const BenefitContainer = styled.div`
    color: ${({ theme }) => theme.text};
    display:flex;
    flex-direction:column;
    h4{
        font-size: 1.2rem;
        color: ${({ theme }) => theme.text};
        margin: .5rem;
    }
    p{
        font-size: 1rem;
        color: ${({ theme }) => theme.text};
        font-weight:300;

    }
    /*mobile view */
    @media (max-width: 750px){
        padding-top: 1rem;
        h4 {
            font-size: 1.1rem;
        }
        p {
            font-size: .8rem;
        }
    }
   
`
const StyledImg = styled.img`
    width: 80px;
    align-self: center;

    /*mobile version*/
    @media(max-width: 750px){
        width: 80px;
    }
`

const BenefitsSection = ({ data }) => {
    return (
        <React.Fragment>
            <BenefitsWrapper>
                <Columns>
                    <BenefitContainer>
                        <StyledImg src={zen} />
                        <h4>
                            Simplu
                        </h4>
                        <p>
                            În 3 pași ești gata să dai print
                        </p>
                    </BenefitContainer>
                    <BenefitContainer>
                        <StyledImg src={heart} />

                        <h4>
                            Personalizabil
                        </h4>
                        <p>
                            Numele tău și al grădiniței pe fiecare fișă
                        </p>
                    </BenefitContainer>
                    <BenefitContainer>
                        <StyledImg src={speed} />
                        <h4>
                            Foarte rapid
                        </h4>
                        <p>
                            Cel mai rapid mod de a pregăti o săptămână
                        </p>
                    </BenefitContainer>
                </Columns>
            </BenefitsWrapper>
        </React.Fragment>
    )
}

export default BenefitsSection;